import React, { useEffect, useState } from 'react';
import { model } from '@whizz/api-client';
import { Loader } from '../../components';
import { StudentPin } from '../../components/studentPin/StudentPin';

interface Props {
  studentId: number;
  type?: 'password' | 'pin';
  /**
   * Controls whether password should be fetched. Defaults to true.
   */
  fetch?: boolean;
}

// TODO: state of passwords to avoid a call everytime it renders
const StudentsPassword = ({ studentId, type = 'password', fetch = true }: Props): JSX.Element => {
  const [ loading, setLoading ] = useState(true);
  const [ password, setPassword ] = useState('');
  const fn = type === 'pin' ? 'getStudentPin' : 'getStudentPassword';
  useEffect( () => {
    if (fetch) {
      setLoading(true);
      new model.Student({
        id: studentId,
      })[fn]()
        .then((pass) => setPassword(pass))
        .catch((err) => console.log('Error getting password', err))
        .finally(() => setLoading(false));
    }
  }, [ studentId, fetch ]);

  return (
    loading
      ? <Loader disableLabel={true} style={{ display: 'inline-block' }}/>
      : <>{type === 'pin' ? <StudentPin pin={password} /> : password}</>
  );
};

export default StudentsPassword;
